import React from 'react';

/**
 * Drop-in replacement for Atlaskit's <ModalTransition>.
 * Our CustomModal handles its own animations, so this is a transparent pass-through.
 *
 * @param {Object} props - Component props.
 * @param {ReactNode} props.children - Child elements.
 * @returns {ReactElement}
 */
const CustomModalTransition = ({ children }) => <>{children}</>;

export default CustomModalTransition;
